import EventTypes from '../../shared/EventTypes';
import AbstractSideBar from '../AbstractSideBar';
import ElementsTab from '../ElementsTab';
import PlantsTab from '../PlantsTab';
import InfoTab from './InfoTab';

export default class SideBar extends AbstractSideBar {
    init() {
        this.options = ['info', 'elements', 'plants'];
        super.init();
        this.tabs = {
            'info': new InfoTab(this.provider, this.tabContainer),
            'elements': new ElementsTab(this.provider, this.tabContainer),
            'plants': new PlantsTab(this.provider, this.tabContainer),
        };

        this.tabContainer.size(this.labelWidth, this.labelHeight * Object.keys(this.tabs).length);
    }

    activate() {
        this.openTab = this.tabs['plants'];
        this.openTab.activate();
        if (this.mobile) {
            this.emit(EventTypes.CLOSE_SIDEBAR);
        }
    }
}
